export default {
  DIVIT: 'divit',
  HKEXPRESS: 'hkexpress',
  CATHAY: 'cathay',
  ASIAMILES: 'asiamiles',
}
